<template>
    <select class="fieldselect"
            v-model="item.value"
            multiple
            size="4">
        <option
            v-for="(relType, val) in relTypes"
            :key="val"
            :value="val"
            v-text="relType">
        </option>
    </select>
</template>

<script>
import {get} from 'lodash'
import {Listeners} from "../../../constants/listeners";
import {FilterConstants} from "keysso/constants/filterConstants";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data: () => ({
        relTypes: [],
    }),
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },
        loadPostTypes() {
            this.relTypes = this.$tm('lang.report.backlinks.relTypes');
        },
        parsePresetValue() {
            let value = this.item.value;
            if(Array.isArray(value)) {
                return;
            }

            if(typeof value !== 'string') {
                this.item.value = [];
                return;
            }

            this.item.value = value.split(FilterConstants.FILTER_ARRAY_DELIMITER);
        },
        setDefaultValue() {
            let value = Array.isArray(this.item.value) ? this.item.value : [];
            const defaultRelType = get(this.relTypes, '0');
            if(!defaultRelType) {
                return;
            }

            value = value.length > 0 ? value : [0];
            this.item.value = value;
        },
        init() {
            this.parsePresetValue();
            this.loadPostTypes();
            this.setDefaultValue();
        }
    },
    created() {
        this.init();
    },
}
</script>
